import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../firebase/AuthProvider';
import Ticket from '../../../interfaces/ticket/Ticket';
import { getTickets } from '../../../services/ticketServices/TicketService';
import IssuesPageTable from '../IssuesPage/IssuesPageTable';
import Loader from '../loader/Loader';
import IssueSidebar from '../issuePage/IssueSidebar';

const SprintDetailPage: React.FC = () => {
    const { sprintId } = useParams<{ sprintId: string }>();
    const { currentUser } = useAuth();
    const [tickets, setTickets] = useState<Ticket[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [selectedTicketId, setSelectedTicketId] = useState<string | null>(null);

    const handleTicketUpdate = (updatedTicket: Ticket) => {
        setTickets(prevTickets =>
            prevTickets.map(ticket =>
                ticket.id === updatedTicket.id ? updatedTicket : ticket
            )
        );
    };

    const handleCloseSidebar = useCallback(() => {
        setSelectedTicketId(null);
    }, []);

    useEffect(() => {
        const fetchTickets = async () => {
            if (!currentUser || !sprintId) return;
            setIsLoading(true);
            setError(null);
            try {
                const token = await currentUser.getIdToken();
                const response = await getTickets(token, {
                    sprintId: sprintId,
                    skip: (currentPage - 1) * pageSize,
                    take: pageSize
                });
                setTickets(response?.tickets || []);
                setTotalCount(response?.totalCount || 0);
            } catch (err) {
                setError('Failed to fetch sprint details.');
                console.error(err);
            } finally {
                setIsLoading(false);
            }
        };

        fetchTickets();
    }, [currentUser, sprintId, currentPage, pageSize]);

    console.log('tickets');

    if (error) {
        return <div className="alert alert-danger">{error}</div>;
    }

    return (
        <div className="p-3 tasks_page_container shadow-sm">
            <div className="top top_bar_flx">
                <div className="top_bar_tittle">
                    <h2>Sprint Details</h2>
                </div>
            </div>
            <IssuesPageTable
                tickets={tickets}
                displayTicketCount={true}
                page={currentPage}
                pageSize={pageSize}
                totalCount={totalCount}
                isLoading={isLoading}
                onPageChange={setCurrentPage}
                setPage={setCurrentPage}
                setPageSize={setPageSize}
                onTicketClick={setSelectedTicketId}
            />
            <IssueSidebar 
                issueId={selectedTicketId}
                onClose={handleCloseSidebar}
                onTicketUpdate={handleTicketUpdate}
            />
        </div>
    );
}

export default SprintDetailPage;
